import { render, staticRenderFns } from "./MaterialUsatCrud.vue?vue&type=template&id=f1208e44&scoped=true&"
import script from "./MaterialUsatCrud.vue?vue&type=script&lang=js&"
export * from "./MaterialUsatCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1208e44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
